import React, {useState, useEffect} from "react";
import { UNICON_THEME } from "../../config/api.config";

const TabView = ({ myTabs, selectedTab, border }) => {
    const [size, setSize] = useState({ width: 0, height: 0 });

    useEffect(() => {
        if (myTabs[selectedTab]?.ref.current) {
            setSize({
                width: myTabs[selectedTab]?.ref.current.offsetWidth,
                height: myTabs[selectedTab]?.ref.current.clientHeight,
            });
        }
    }, [selectedTab]);

    const handleLeftShift = () => {
        if (myTabs[selectedTab - 1]?.ref.current) {
            return myTabs[selectedTab - 1]?.ref.current.offsetWidth;
        }
        return 1;
    };

    return (
        <div className=" flex flex-row font-manrope-regular items-center justify-start gap-2.5 relative">
            {myTabs.length > 0 &&
                myTabs.map((item, index) => {
                return (
                    <div
                        ref={item?.ref}
                        key={`${item?.name}-${index}`}
                        className="cursor-pointer flex flex-row items-center justify-center"
                        onClick={() => { item.onClick(); }}
                    >
                        <span
                            className={`${
                            selectedTab == index
                                ? `text-text_color_primary2 ${UNICON_THEME? "":(border?"bg-bg_text_brand_primary":"bg-bg_text_racing_primary")} `
                                : " text-text_color_primary1 bg-bg_color_primary"
                            } px-[25px] py-1  text-[13px] text-sm  ${border?"rounded-md":"rounded-full"} md:text-sm lg:text-base font-bold leading-6 active:scale-95 block z-10 `}
                        >
                            {item?.name}
                        </span>
                    </div>
                );
            })}

            <div
                className="absolute z-1 w-full h-full transition-all ease-in-out duration-150 bg-bg_Primary text-sm bg-bg_Primary rounded-full border border-primary"
                style={{
                    width: `${size?.width}px`,
                    top: "1px",
                    left: `${
                        selectedTab * (selectedTab > 0 ? handleLeftShift() : 1) +
                        selectedTab * 10
                    }px`,
                    height: `${size?.height}px`,
                }}
            ></div>
        </div>
    );
};


export default TabView;